export const DATES = ['01-01',
'01-02',
'01-03',
'01-04',
'01-05',
'01-06']

export function getDatesMarks() {
    const marks = {};
    DATES.forEach((y, i) => {
        marks[i] = y;
    });
    return marks;
}

export const VIEW_STATES = {
    INITAL: {
        latitude: 7.250,
        longitude: 133.23,
        zoom: 6.5,
        bearing: 0,
        pitch: 0
    },
    SECOND: {
        latitude: 7.250,
        longitude: 133.23,
        zoom: 6.5,
        bearing: 0,
        pitch: 0
    },
    THIRD: {
        latitude: 7.250,
        longitude: 133.23,
        zoom: 6.5,
        bearing: 0,
        pitch: 0
    }
    // SECOND: {
    //     latitude: 7.55,
    //     longitude: 133.4,
    //     zoom: 7.5,
    //     bearing: 0,
    //     pitch: 15
    // },
    // THIRD: {
    //     latitude: 7.55,
    //     longitude: 133.4,
    //     zoom: 7.5,
    //     bearing: 0,
    //     pitch: 15
    // },
};

// export const documentationMap = {
//   // Example for "Amount of Hot Days" matching your image
//   '2.2.1.3': { // This key must match your 'scatterplotVariable' value
//     title: "Amount of Hot Days",
    
//     // SECTION 1: Summary
//     summaryContent: (
//       <>
//         A specific calendar date for a given year is determined to be a “hot day” 
//         by calculating if its maximum surface air temperature is greater than the 
//         90th percentile of maximum surface air temperature for the collection of 
//         five days centered on the same calendar day within the base period of 
//         1961-1990. For dates that fall within the base period, a bootstrap 
//         approach is used to avoid inhomogeneity. The data is obtained from the 
//         Global Historical Climatology Network daily (GHCNd) Koror station.
//         <br /><br />
//         Further documentation about the dataset is available at{' '}
//         <Link href="https://www.ncei.noaa.gov/products/land-based-station/global-historical-climatology-network-daily" target="_blank" rel="noopener">
//             NCEI NOAA
//         </Link>{' '}
//         and further documentation about the climate index is found on{' '}
//         <Link href="https://climpact-sci.org/indices/#index-TX90p" target="_blank" rel="noopener">
//             Climpact Sci
//         </Link>.
//       </>
//     ),

//     // SECTION 2: Mathematical Description
//     mathSubHeader: "Percentage of days when TX > 90th percentile",
//     mathContent: (
//       <>
//         Let Txij be the daily maximum temperature on day i in period j and let 
//         TXin90 be the calendar day 90th percentile centred on a 5-day window for 
//         the base period 1961-1990. The percentage of time for the base period is 
//         determined where TXij > TXin90.
//         <br /><br />
//         To avoid possible inhomogeneity across the in-base and out-base periods, 
//         the calculation for the base period (1961-1990) requires the use of a 
//         bootstrap procedure.
//       </>
//     )
//   },

//   // Fallback for other variables
//   'default': {
//     title: "Variable Documentation",
//     summaryContent: "Select a variable to see the summary.",
//     mathSubHeader: "",
//     mathContent: "No mathematical description available."
//   }
// };